import ogImageURL from 'assets/ogImages/ogImage4.jpg';
import Metadata from 'components/Metadata';
import PropTypes from 'prop-types';
import React from 'react';
import Banner from './Banner';
import Customers from './Customers';
import Features from './Features';
import PricingCal from './PricingCal';
import QAComp from './QA';

const SMETpl = ({ data }) => {
  const {
    SMEPages: {
      title,
      meta: { description },
      banner, check, videos, features, customers, pricingInfo, QA
    },
    caseSelected: {
      nodes
    }
  } = data;
  return (
    <div>
      <Metadata title={title} description={description} ogImage={ogImageURL} customizedTitle={true} />
      <Banner banner={banner} check={check} />
      <Features features={features} videos={videos} />
      <Customers data={nodes} customers={customers} />
      <PricingCal data={pricingInfo} />
      <QAComp data={QA} />
    </div>
  );
};

SMETpl.propTypes = {
  data: PropTypes.object,
};

export default SMETpl;
